export const pwdRegex = new RegExp(
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[~@#$&%^&!*`])[A-Za-z0-9~@#$&%^&!*`]{8,20}$/
);

export const mobRegex = new RegExp(
  /(?:\+?61)?(?:\(0\)[23478]|\(?0?[23478]\)?)\d{8}/
);
